import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import {Col, Row} from 'reactstrap';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { updateProfile } from '../../../store/actions/user';
import { EditProfileSchema } from '../../../helpers/schemas';
import { Messages } from "../../layout/Messages/Messages";
import * as Notifications from "../../../config/notifications";
import { hideNotification } from "../../../store/actions/notification";
import {CustomField} from "./CustomField";
import { PageSurface } from '../../layout/Workspace';

const EditUserDetailsComponent = (props) => {
    let { first_name, last_name, email, groups } = props.profile;
    const { updateProfile } = props;
    first_name = first_name ?? '';
    last_name = last_name ?? '';
    email = email ?? '';

    const userGroups = []
    groups.forEach(group => {
      userGroups.push(group.name)
    })

    return (
      <PageSurface
        className="profile-panel profile-user-panel"
        header={<h2 className="profile-panel-title"><FormattedMessage id="components.pages.profile.edit_profile.user_information" /></h2>}
      >
          <Formik
            initialValues={{
              firstName: first_name,
              lastName: last_name,
              email: email
            }}
            validationSchema={ EditProfileSchema }
            enableReinitialize={ true }
            onSubmit={
              (values,{setSubmitting}) => {
                const { firstName, lastName, email } = values;
                updateProfile(firstName, lastName, email);
                setSubmitting(false)
              }
            }
          >
            {(props) => (
              <Fragment>
                <Messages
                  notificationId={ Notifications.NOTIFICATION_EDIT_USER_DETAILS }
                  formikProps={ props }
                >
                  <ErrorMessage name="firstName" component="div" data-testid="errors-firstName" className="field-error" />
                  <ErrorMessage name="lastName" component="div" data-testid="errors-lastName" className="field-error" />
                  <ErrorMessage name="email" component="div" data-testid="errors-email" className="field-error" />
                </Messages>
                <Form>
                  <Row>
                    <Col lg="12">
                      <CustomField
                        label="components.pages.profile.edit_profile.last_name_label"
                        fieldName="lastName"
                        value={ props.values.lastName }
                        onChange={
                          event => {
                            props.setFieldValue('lastName', event.target.value);
                          }
                        }
                        handleBlur={ props.handleBlur }
                        key={ props.isSubmitting }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <CustomField
                        label="components.pages.profile.edit_profile.first_name_label"
                        fieldName="firstName"
                        value={ props.values.firstName }
                        onChange={
                          event => {
                            props.setFieldValue('firstName', event.target.value);
                          }
                        }
                        handleBlur={ props.handleBlur }
                        key={ props.isSubmitting }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <CustomField
                        label="components.pages.profile.edit_profile.email_label"
                        fieldName="email"
                        isDisabled={true}
                        type="email"
                        value={ props.values.email }
                        onChange={
                          event => {
                            props.setFieldValue('email', event.target.value);
                          }
                        }
                        handleBlur={ props.handleBlur }
                        key={ props.isSubmitting }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <CustomField
                        label="components.pages.profile.edit_profile.roles_label"
                        fieldName="roles"
                        isDisabled={true}
                        value={ userGroups.join(', ') }
                        onChange={
                          event => {
                            props.setFieldValue('roles', event.target.value);
                          }
                        }
                        handleBlur={ props.handleBlur }
                        key={ props.isSubmitting }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <FormattedMessage id="components.pages.profile.edit_profile.save_profile_btn">
                      {
                        valueBtn => <Field className="my-4 btn btn-primary mx-auto" type="submit" value={valueBtn} />
                      }
                    </FormattedMessage>
                  </Row>
                </Form>
              </Fragment>
            )}
          </Formik>
      </PageSurface>
    );
}

EditUserDetailsComponent.defaultProps = {
  hideNotification: hideNotification
}

const mapStateToProps = state => ({
  profile: state.user.profile,
});

const mapActionsToProps = {
  updateProfile,
  hideNotification
}

const EditUserDetails = connect(mapStateToProps, mapActionsToProps)(EditUserDetailsComponent);
export { EditUserDetails, EditUserDetailsComponent };
